module.exports = __webpack_public_path__ + "back.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back.png
// module id = 135
// module chunks = 0